module.exports = __webpack_public_path__ + "static/media/headset.44610f12.svg";